import { useRef } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition';

import type { EditionAwarenessDataType } from './DataType';

const ANALYTICS_SOURCE_EDITION_AWARENESS = 'editionAwareness';

export const EditionAwarenessAudienceTimingChecker = ({
	data,
}: {
	data: EditionAwarenessDataType;
}) => {
	const hasSentAnalyticsEventRef = useRef(false);
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const {
		edition,
		isInTrial,
		canUpgradeAndPayInFreeEdition,
		isPreDunning,
		canAddBillingForTrial,
		hasBillingDetails,
		loading,
	} = data;
	if (loading) {
		return null;
	}
	const shouldRenderFree = edition === ConfluenceEdition.FREE && canUpgradeAndPayInFreeEdition;

	const shouldRenderStandardTrial =
		ConfluenceEdition.STANDARD &&
		(isInTrial || isPreDunning) &&
		!hasBillingDetails &&
		canAddBillingForTrial;

	const shouldRenderPremiumTrial = ConfluenceEdition.PREMIUM && (isInTrial || isPreDunning);

	const analyticsScreenName = shouldRenderFree
		? 'editionAwarenessFree'
		: shouldRenderStandardTrial
			? 'editionAwarenessStandardTrial'
			: shouldRenderPremiumTrial
				? 'editionAwarenessPremiumTrial'
				: 'hideEditionAwareness';

	if (hasSentAnalyticsEventRef && !hasSentAnalyticsEventRef.current) {
		createAnalyticsEvent({
			type: 'sendScreenEvent',
			data: {
				source: ANALYTICS_SOURCE_EDITION_AWARENESS,
				name: analyticsScreenName,
			},
		}).fire();
		hasSentAnalyticsEventRef.current = true;
	}

	return null;
};
